"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigurableListLoader = getConfigurableListLoader;
const dataListLoaders_1 = require("./dataListLoaders");
function getConfigurableListLoader() {
    const dataListLoader = dataListLoaders_1.dataListLoaders['dataListValues'];
    if (!dataListLoader) {
        throw new Error('"dataListValues" is not registered you need to call registerConfigurableListLoader first');
    }
    return dataListLoader;
}
